export default __webpack_public_path__ + "static/68854-4ecd1c3edf95694500b800ae207e6dfe.jpg";